module.exports = __webpack_public_path__ + "img/gazszallitas.54109ff4.jpg";